import {useParams} from 'react-router'
import {observer} from 'mobx-react-lite'
import {useEffect} from 'react'
import clubStore from '../../../storage/ClubStore'
import GameResult from "../../Games/GameResult";

const TrainerShowGame = () => {
  const args = useParams()
  const contest = clubStore.trainer.contest
  useEffect(() => {
    if (args.id) {
      contest.getGame(args.id)
    }
  }, [args.id])
  return (
    <GameResult game={contest.game} role={"TRN"}/>
  )
}

export default observer(TrainerShowGame)